import styles from './styles.module.scss';

import { SelectOption } from '../Select';
import { Button } from '../Button';
import { PopUpBox } from '../PopUpBox';
import { useEffect, useState } from 'react';
import { Tokenizer } from '../Tokenizer';
import { TokenItem } from '../Token';
import { InputCheckbox } from '../InputCheckbox';
import { Input } from '../Input';

type MultipleSelectProps = {
    id: any;
    options: SelectOption[];
    selectedOptions: TokenItem[];
    setSelectedOptions: React.Dispatch<React.SetStateAction<TokenItem[]>>;
    placeholder: string;
    title?: string;
    showTokenizer?: boolean;
    disabled?: boolean;
};

export const MultipleSelect = ({
    id,
    options,
    selectedOptions,
    setSelectedOptions,
    placeholder,
    title,
    showTokenizer = true,
    disabled
}: MultipleSelectProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('');

    // Order by alphabetical order
    const optionsMock: SelectOption[] = options.map(optionMock => {
        return { ...optionMock };
    });
    optionsMock.sort((option1, option2) => option1.text.localeCompare(option2.text));

    const selectedOptionsMock: TokenItem[] = selectedOptions.map(selectedOptionMock => {
        return { ...selectedOptionMock };
    });
    selectedOptionsMock.sort((selectedOption1, selectedOption2) =>
        selectedOption1.text.localeCompare(selectedOption2.text)
    );

    const onSelectOption = (option: SelectOption | TokenItem) => {
        const isInArray =
            selectedOptions.find(selectedOptions => selectedOptions.key === option.key) !==
            undefined;

        const currentSelectedOptions: TokenItem[] = [];

        selectedOptions.forEach((selectedOption: TokenItem) => {
            if (selectedOption.key !== option.key) {
                currentSelectedOptions.push(selectedOption);
            }
        });

        if (!isInArray) {
            currentSelectedOptions.push({
                key: option.key,
                value: option.value,
                text: option.text,
                description: option.description,
                title: option.title,
                extras: option.extras
            });
        }

        setSelectedOptions(currentSelectedOptions);
    };

    const renderSelectedOption = (option: TokenItem) => {
        return (
            <InputCheckbox
                key={`${id}-${option.key}`}
                id={`${id}-${option.key}`}
                text={option.text}
                description={option.description}
                checked={true}
                title={option.title}
                onChange={() => onSelectOption(option)}
            />
        );
    };

    const renderSelectOption = (option: SelectOption) => {
        const isChecked =
            selectedOptions.find(selectedOptions => selectedOptions.key === option.key) !==
            undefined;
        const isInText = option.text.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        const isInDescription =
            option.description &&
            option.description.toLocaleLowerCase().includes(search.toLocaleLowerCase());

        if (!isChecked && (search === '' || isInText || isInDescription)) {
            return (
                <InputCheckbox
                    key={`${id}-${option.key}`}
                    id={`${id}-${option.key}`}
                    text={option.text}
                    description={option.description}
                    checked={isChecked}
                    title={option.title}
                    onChange={() => onSelectOption(option)}
                />
            );
        }
    };

    useEffect(() => {
        if (!open) {
            setSearch('');
        }
    }, [open]);

    return (
        <>
            <Button wrapperClass={styles.button} onClick={() => setOpen(true)} disabled={disabled}>
                {placeholder}
            </Button>

            <PopUpBox wrapperClass={styles.popUpBox} open={open} setOpen={setOpen}>
                {title && <h2 className={styles.title}>{title}</h2>}

                {showTokenizer && (
                    <>
                        <Tokenizer
                            id={`${id}-tokenizer`}
                            tokens={selectedOptions}
                            setTokens={setSelectedOptions}
                        />

                        {selectedOptions.length > 0 && <div className={styles.divider} />}
                    </>
                )}

                <Input
                    type='text'
                    value={search}
                    onChange={(e: any) => setSearch(e.target.value)}
                    //placeholder='Pesquisar'
                />

                <div className={styles.container}>
                    {selectedOptionsMock.map(renderSelectedOption)}
                    {optionsMock.map(renderSelectOption)}
                </div>
            </PopUpBox>
        </>
    );
};
